import * as React from "react";
import { connect } from "react-redux";

import { appAction } from "../../actions/app.action";
import { portfolioAction } from "../../actions/portfolio.action";

import { Button, withStyles } from "@material-ui/core";

import SectionHeader from "../../components/UI/SectionHeader";
import { householdAction } from "../../actions/household.action";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import { TieredFeeDataBox } from "../Cy/components";
import feeAction from "../../actions/fee.action";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "5%",
    },
  },
  custodianListItem: {
    background: theme.palette.grey[100],
  },
});

class UserCustodians extends React.Component {
  constructor(props) {
    super(props);
    const addedCustodianIds = Object.keys(props.userCustodianFees).map((id) =>
      Number(id)
    );
    let fees;
    if (props.userCustodianFees.hasOwnProperty(addedCustodianIds[0] || null)) {
      fees = props.userCustodianFees[addedCustodianIds[0]];
    } else if (
      props.cyCustodianFees.hasOwnProperty(addedCustodianIds[0] || null)
    ) {
      fees = props.cyCustodianFees[addedCustodianIds[0]];
      fees.forEach((fee) => {
        delete fee.id; // remove id from cy custodian fee so that server can create new records for this user
      });
    }
    this.state = {
      selectedCustodianId: null,
      addedCustodianIds: addedCustodianIds,
      custodianIdWithFeeLoaded: addedCustodianIds[0] || null,
      feeSchedules: fees,
    };
  }

  handleSelectCustodian = (e) => {
    this.setState({ selectedCustodianId: Number(e.target.value) });
  };

  handleAddCustodian = () => {
    this.setState({
      selectedCustodianId: null,
      addedCustodianIds: [
        ...this.state.addedCustodianIds,
        this.state.selectedCustodianId,
      ],
    });
  };

  handleRemoveCustodian = (custodianId) => (e) => {
    const { dispatch } = this.props;

    this.setState({
      addedCustodianIds: [...this.state.addedCustodianIds].filter(
        (c) => c !== custodianId
      ),
      custodianIdWithFeeLoaded:
        this.state.custodianIdWithFeeLoaded === custodianId
          ? null
          : this.state.custodianIdWithFeeLoaded,
    });
    dispatch(feeAction.removeCustodian(this.props.user.user.id, custodianId));
  };

  loadCustodianFee = (custodianId) => (e) => {
    const { cyCustodianFees, userCustodianFees } = this.props;

    const userFees = userCustodianFees[custodianId];

    const defaultFees = cyCustodianFees[custodianId];

    let fees = userFees || defaultFees || [];
    fees.forEach((fee) => {
      delete fee.id; // remove id from cy custodian fee so that server can create new records for this user
    });
    this.setState({
      custodianIdWithFeeLoaded: custodianId,
      feeSchedules: fees,
    });
  };

  saveFeeSchedule = (entityType, entityId) => (feeSchedules) => {
    const { dispatch } = this.props;

    if (entityType === "custodian") {
      dispatch(
        feeAction.updateAdvisorCustodian(
          feeSchedules,
          this.props.user.user.id,
          entityId
        )
      );
    } else {
      throw new Error("unknown action");
    }
  };

  componentDidMount() {
    this.props.dispatch(portfolioAction.clearCurrentPortfolio());
    this.props.dispatch(householdAction.clearCurrentHousehold());
    this.props.dispatch(appAction.setUsersNav(true));
    this.props.dispatch(appAction.toggleMainNav(false));
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {}

  render() {
    const { classes, custodians, userCustodianFees, cyCustodianFees } =
      this.props;
    const { addedCustodianIds, custodianIdWithFeeLoaded, selectedCustodianId } =
      this.state;
    const loadedCustodian = custodians.find(
      (c) => c.id === custodianIdWithFeeLoaded
    );

    // Begin Cascade logic to assign fee schedules
    let feeSchedules = [];
    if (userCustodianFees.hasOwnProperty(custodianIdWithFeeLoaded)) {
      feeSchedules = userCustodianFees[custodianIdWithFeeLoaded];
    } else if (cyCustodianFees.hasOwnProperty(custodianIdWithFeeLoaded)) {
      feeSchedules = cyCustodianFees[custodianIdWithFeeLoaded];
      feeSchedules.forEach((fee) => {
        delete fee.id; // remove id from cy custodian fee so that server can create new records for this user
      });
    }
    // End Cascade logic to assign fee schedules

    const custodiansNotAdded = [...custodians].filter((c) => !addedCustodianIds.includes(c.id));

    return (
      <Fade in>
        <div className={classes.contentWrapper}>
          <div className={classes.content}>
            <Grid container>
              <Grid item xs={12}>
                <SectionHeader text={"Custodians"} />
              </Grid>
              {
                custodiansNotAdded.length > 0 && (<Grid item xs={12}>
                <Typography variant={"body2"}>Add custodian</Typography>
                <Select
                  native
                  onChange={this.handleSelectCustodian}
                  style={{ minWidth: 150 }}
                >
                  <option />
                  {custodiansNotAdded.map((custodian) => (
                    <option value={custodian.id} key={custodian.id}>
                      {custodian.name}
                    </option>
                  ))}
                </Select>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.handleAddCustodian}
                  disabled={!selectedCustodianId}
                  style={{ marginLeft: 16 }}
                >
                  Add
                </Button>
              </Grid>)
            }
              <Divider style={{ margin: "40px 0" }} />
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={3}>
                <List>
                  {addedCustodianIds.map((custodianId) => (
                    <React.Fragment key={custodianId}>
                      <ListItem
                        className={classes.custodianListItem}
                        button
                        selected={custodianId === custodianIdWithFeeLoaded}
                        onClick={this.loadCustodianFee(custodianId)}
                      >
                        <ListItemText
                          primary="Custodian Fee"
                          primaryTypographyProps={{ variant: "caption" }}
                          secondary={
                            custodians.find((c) => c.id === custodianId).name
                          }
                          secondaryTypographyProps={{
                            variant: "body1",
                            color:
                              custodianId === custodianIdWithFeeLoaded
                                ? "primary"
                                : "initial",
                          }}
                        />
                        <ListItemSecondaryAction>
                          {custodians.find((c) => c.id === custodianId).allowDefaultFeeOverride && (
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              size="small"
                              onClick={this.handleRemoveCustodian(custodianId)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} sm={1} />
              <Grid item xs={12} sm={6}>
                {custodianIdWithFeeLoaded && (
                  <React.Fragment>
                    <TieredFeeDataBox
                      title={
                        <Typography variant={"h5"} gutterBottom>
                          {loadedCustodian.name}
                        </Typography>
                      }
                      description={
                        loadedCustodian.allowDefaultFeeOverride &&
                        <Typography variant={"body1"} gutterBottom>
                          These default values may be customized for each
                          household. Change will apply from today going forward.
                        </Typography>
                      }
                      readonly={!loadedCustodian.allowDefaultFeeOverride}
                      onSaveFeeSchedules={this.saveFeeSchedule(
                        "custodian",
                        custodianIdWithFeeLoaded
                      )}
                      feeSchedules={feeSchedules}
                    />
                    <Typography variant={"body1"} >
                      { loadedCustodian.feeDisclaimer }
                    </Typography>
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </Fade>
    );
  }
}

const mapStateToProps = (state) => {
  const { custodians } = state.custodian;

  const { cyCustodianFees, userCustodianFees } = state.fee;

  const ourUserCustodianFeesProps = userCustodianFees[state.user.user.id] || {};

  return {
    app: state.app,
    user: state.user,
    portfolio: state.portfolio,
    custodians,
    cyCustodianFees: cyCustodianFees,
    userCustodianFees: ourUserCustodianFeesProps,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(UserCustodians)
);



// WEBPACK FOOTER //
// ./src/containers/UserCustodians/index.jsx